module.exports = __webpack_public_path__ + "img/Artboard – 1 (3).4b73afe7.png";